import React from 'react';

const CovChecklistPage: React.FunctionComponent<any> = () => {
  return (
    <div>
      <h3>COV Checklist Page</h3>
    </div>
  );
};

export default CovChecklistPage;
